import React from 'react';
import Helmet from 'react-helmet';
import AuthLayout from '../../components/AuthLayout';
import Success from '../../components/Survey/Warning';

export default function SurveyForm({ id }) {
  return (
    <AuthLayout hideImage={true}>
      <Helmet>
        <title>YKB Emekli Sandığı Vakfı Anket</title>
      </Helmet>
      <Success id={id} />
    </AuthLayout>
  );
}
